module.exports = __webpack_public_path__ + "img/addUser.6426b255.svg";